/**
 * HTML signature appended to outbound composer emails. Inline styles match
 * `_email-composer.scss` `&__signature` ($c-text-sec, $c-primary, $c-border).
 */
const signatureColors = {
  textSecondary: "#8a8fa9",
  primary: "#0e93e5",
  border: "#e6ecf5",
};

const escapeHtml = (value) => {
  if (value === undefined || value === null) {
    return "";
  }
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
};

export const buildComposerSignatureHtml = ({
  labelLine,
  advisorName,
  advisorPhone,
}) => {
  const parts = [];
  const label = String(labelLine ?? "").trim();
  const name = String(advisorName ?? "").trim();
  const phone = String(advisorPhone ?? "").trim();

  if (label) {
    parts.push(
      `<p style="margin:0 0 8px 0;color:${signatureColors.textSecondary};font-size:13px;line-height:1.6;">${escapeHtml(label)}</p>`,
    );
  }
  if (name) {
    parts.push(
      `<p style="margin:0 0 4px 0;color:${signatureColors.primary};font-size:13px;font-weight:500;line-height:1.6;">${escapeHtml(name)}</p>`,
    );
  }
  if (phone) {
    parts.push(
      `<p style="margin:0;color:${signatureColors.textSecondary};font-size:13px;line-height:1.6;">${escapeHtml(phone)}</p>`,
    );
  }

  if (parts.length === 0) {
    return "";
  }
  return `<div style="margin-top:16px;padding-top:12px;border-top:1px solid ${signatureColors.border};">${parts.join("")}</div>`;
};

export const appendComposerSignatureToHtml = (bodyHtml, signatureHtml) => {
  const body = bodyHtml || "";
  if (!signatureHtml) {
    return body;
  }
  const separator = body.trim() ? "<br><br>" : "";
  return `${body}${separator}${signatureHtml}`;
};
